import React, { useState } from 'react';

export default function MultiplePuzzle({ data, onSolved }) {
  const [selected, setSelected] = useState(null);
  const [wrong, setWrong] = useState(false);

  const handleSelect = (option) => {
    setSelected(option);
    if (option === data.correctAnswer) {
      setTimeout(onSolved, 600);
    } else {
      setWrong(true);
      setTimeout(() => {
        setWrong(false);
        setSelected(null);
      }, 1000);
    }
  };

  return (
    <div className="puzzle-multiple">
      <p className="puzzle-prompt">{data.prompt}</p>
      <div className="multiple-options">
        {data.options.map((option) => (
          <button
            key={option}
            className={`multiple-option ${
              selected === option
                ? option === data.correctAnswer
                  ? 'option-correct'
                  : 'option-wrong'
                : ''
            }`}
            onClick={() => handleSelect(option)}
            disabled={selected !== null}
          >
            {option}
          </button>
        ))}
      </div>
      {wrong && <p className="puzzle-wrong">Nope! Try again 💭</p>}
    </div>
  );
}
